"use strict";

angular.module("core").directive("backbutton", function() {
    return {
        restrict: "E",
        replace: true,
        template: function(tElement, tAttrs) {
            var TempElement = $("<a>").attr("href", "#Back").attr("wg-click", "GoBack()");
            $.each(tAttrs.$attr, function(AttrName) {
                TempElement.attr(AttrName, tElement.attr(AttrName));
            });
            TempElement.append(tElement.contents());
            return $("<div>").append(TempElement).html();
        },
        controller: ["$scope", "$window", function($scope, $window) {
            $scope.GoBack = function() {
                $window.history.back();
            };
        }]
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/deprecated/BackButton.js
// module id = 672
// module chunks = 0